import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FilterControl } from '../../../interfaces/filter-control';
import { FilterControlParams } from '../../../interfaces/filter-control-params';

@Component({
  selector: 'bm-text-filter',
  templateUrl: './text-filter.component.html',
  styleUrls: ['./text-filter.component.scss']
})
export class TextFilterComponent implements FilterControl, OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() control: FilterControlParams;

  constructor() {}

  ngOnInit() {}

}
